module.exports = __webpack_public_path__ + "img/dashboard-sidebar-desktop-ru.f7d198bc.jpg";